import { getUser } from '~/v2/helpers/workspace-helper'
import { isUserScalisAdmin } from '~/v2/helpers/workspace-helper'

export enum FEATURE_FLAGS {
  SCALIS_MATCHES,
  CRM,
  CRM_AI_SOURCING_AGENT,
  NOTIFICATION_PREFERENCES,
  EMAIL_SETTINGS,
  EMAIL_VIEW,
  APPROVAL_WORKFLOWS,
  CREATE_WORKSPACE,
  SCHEDULER_V3,
}

const enabledFeaturesByEnvironment: Record<string, FEATURE_FLAGS[]> = {
  local: [
    FEATURE_FLAGS.EMAIL_VIEW,
    FEATURE_FLAGS.EMAIL_SETTINGS,
    FEATURE_FLAGS.CRM,
    FEATURE_FLAGS.CREATE_WORKSPACE,
    FEATURE_FLAGS.APPROVAL_WORKFLOWS,
    FEATURE_FLAGS.SCHEDULER_V3,
    FEATURE_FLAGS.CRM_AI_SOURCING_AGENT,
  ],
  development: [
    FEATURE_FLAGS.EMAIL_SETTINGS,
    FEATURE_FLAGS.CRM,
    FEATURE_FLAGS.CREATE_WORKSPACE,
    FEATURE_FLAGS.SCHEDULER_V3,
    FEATURE_FLAGS.CRM_AI_SOURCING_AGENT,
  ],
  staging: [FEATURE_FLAGS.EMAIL_SETTINGS, FEATURE_FLAGS.CRM, FEATURE_FLAGS.CRM_AI_SOURCING_AGENT],
  production: [FEATURE_FLAGS.EMAIL_SETTINGS, FEATURE_FLAGS.CRM, FEATURE_FLAGS.CRM_AI_SOURCING_AGENT],
}

/**
 * Checks if a feature flag is enabled
 * @param featureFlag The feature flag to check
 * @returns boolean indicating if the feature is enabled
 */
const displayFeature = (featureFlag: FEATURE_FLAGS, user?: Awaited<ReturnType<typeof getUser>> | null): boolean => {
  const enabledFeatures = enabledFeaturesByEnvironment[process.env.NEXT_PUBLIC_ENV ?? '']

  if (enabledFeatures) {
    return enabledFeatures.includes(featureFlag) || (user ? isUserScalisAdmin(user) : false)
  }

  return false
}

export { displayFeature }
